import React, { createContext, useContext, useEffect } from "react";
import socket from "./socket";

const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
  useEffect(() => {
    // Connect to the server
    socket.connect();
    
    // Log connection status
    socket.on("connect", () => {
      console.log("Socket connected");
    });
    
    socket.on("disconnect", () => {
      console.log("Socket disconnected");
    });

    // Cleanup on unmount
    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
